import { LitElement, html, svg } from 'lit';

export class IconAds16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Ark med bilde og overskrift</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 4H4v3h8V4ZM4 11h8"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2 1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1Z"></path></svg>`; }
}
if (!customElements.get('f-icon-ads16', IconAds16)) {
  customElements.define('f-icon-ads16', IconAds16);
}